import "client-only"
import { useEffect, useEffectEvent, useRef } from "react"

/**
 * Invoke a callback when the given event occurs on the window.
 * Automatically handles callback stability, so `useCallback` is NOT required.
 */
export function useWindowEvent<EventType extends keyof WindowEventMap>(
  eventType: EventType,
  listener: (this: Window, event: WindowEventMap[EventType]) => void,
  options?: boolean | AddEventListenerOptions,
): void {
  const optionsRef = useRef(options)

  const handler = useEffectEvent((event: WindowEventMap[EventType]) => {
    listener.call(window, event)
  })

  useEffect(() => {
    const options = optionsRef.current

    window.addEventListener(eventType, handler, options)

    return () => {
      window.removeEventListener(eventType, handler, options)
    }
  }, [eventType])
}
